import * as React from 'react';
import { GridCustomCellProps } from "@progress/kendo-react-grid";

export default class SecondsCell extends React.Component<GridCustomCellProps> {
  render() {
    if (!this.props.field || this.props.rowType !== 'data') return null;

    return (
      <td {...this.props.tdProps}>
        {(new Date(this.props.dataItem[this.props.field] * 1000)).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0]}
      </td>
    );
  }

  public shouldComponentUpdate(nextProps: GridCustomCellProps) {
    return this.props.dataItem[this.props.field] !== nextProps.dataItem[this.props.field];
  }
}
